import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { K2TimeSeriesEdit } from "./edit";
import { K2TimeSeriesNew } from "./new";
import { K2TimeSeriesTable } from "./table";

export default function K2TimeSeries() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Valorisation");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<K2TimeSeriesEdit />} />
      <Route index element={<K2TimeSeriesTable />} />
      <Route path="/new" element={<K2TimeSeriesNew />} />
    </Routes>
  );
}
